/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import useLocaleHelper from "@/hooks/useLanguageHelper";
import { I18nCountry, I18nextLanguage } from "@/types/types";

type SelectByLocaleProps = {
  children: JSX.Element | JSX.Element[];
  visibleIfCountry?: I18nCountry;
  visibleIfLanguage?: I18nextLanguage;
  and?: boolean;
};

export const SelectByLocale = ({
  children,
  visibleIfLanguage,
  visibleIfCountry,
  and = false,
}: SelectByLocaleProps): JSX.Element | null => {
  const { currentLanguage, currentCountry } = useLocaleHelper();
  const operator = and ? "&&" : "||";

  if (
    eval(
      `visibleIfLanguage === currentLanguage ${operator} visibleIfCountry === currentCountry`
    )
  )
    return <React.Fragment>{children}</React.Fragment>;

  return null;
};

export default SelectByLocale;
